import { IconButton, styled } from '@material-ui/core';

import { FloatingPopover } from '../FloatingPopover';
import { TAG_ICONS, TAG_ICON_COMPONENTS, type TagIconName } from './constants';

const IconGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: 'var(--encore-spacing-tighter-4)',
});

type TagIconPickerProps = {
  anchorEl: HTMLElement;
  onSelect: (icon: TagIconName) => void;
  onClose: () => void;
  currentIcon: TagIconName;
};

export const TagIconPicker = ({
  anchorEl,
  onSelect,
  onClose,
  currentIcon,
}: TagIconPickerProps) => {
  return (
    <FloatingPopover
      isOpen
      onClose={onClose}
      anchorElement={anchorEl}
      width="fit-content"
      maxWidth="200px"
      p="2"
    >
      <IconGrid>
        {TAG_ICONS.map(iconName => {
          const IconComponent = TAG_ICON_COMPONENTS[iconName];
          return (
            <IconButton
              key={iconName}
              color={iconName === currentIcon ? 'primary' : 'default'}
              size="small"
              aria-label={iconName}
              onClick={() => onSelect(iconName)}
            >
              <IconComponent size={18} />
            </IconButton>
          );
        })}
      </IconGrid>
    </FloatingPopover>
  );
};
